import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Trending from "./components/Trending";
import Board from "./components/Board";
import Categories from "./components/Categories";
import Guide from "./components/Guide";
import Story from "./components/Story";
import Faq from "./components/Faq";
import Subscribe from "./components/Subscribe";
import Footer from "./components/Footer";
import BackTop from "./components/BackTop";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Trending />
        <Board />
        <Categories />
        <Guide />
        <Story />
        <Faq />
        <Subscribe />
      </main>
      <Footer />
      <BackTop />
    </>
  );
}